import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
export const CompanyToContactApi = {
  SetLink: {
    useQuery: (dto: server.dto.SetCompanyToContactLinkInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["CompanyToContact.SetLink", dto],
      queryFn: () => window.CoreApi.CompanyToContact.SetLink(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.SetCompanyToContactLinkInstruction) => ["CompanyToContact.SetLink", dto]
  }, 
  DeleteLink: {
    useQuery: (dto: server.dto.DeleteCompanyToContactLinkInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["CompanyToContact.DeleteLink", dto],
      queryFn: () => window.CoreApi.CompanyToContact.DeleteLink(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.DeleteCompanyToContactLinkInstruction) => ["CompanyToContact.DeleteLink", dto]
  }, 
  ListCompanyByContact: {
    useQuery: (dto: server.dto.ListCompanyByContactInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.CompanyWithWorkRelation[]>>) => useQuery({
      queryKey: ["CompanyToContact.ListCompanyByContact", dto],
      queryFn: () => window.CoreApi.CompanyToContact.ListCompanyByContact(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.ListCompanyByContactInstruction) => ["CompanyToContact.ListCompanyByContact", dto]
  }, 
  ListContactByCompany: {
    useQuery: (dto: server.dto.ListContactByCompanyInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.ContactWithWorkRelation[]>>) => useQuery({
      queryKey: ["CompanyToContact.ListContactByCompany", dto],
      queryFn: () => window.CoreApi.CompanyToContact.ListContactByCompany(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.ListContactByCompanyInstruction) => ["CompanyToContact.ListContactByCompany", dto]
  }, 

}
